const positive = (value) => {
  const n = Number(value);
  return value != null && value !== "" && Number.isFinite(n) && n > 0
    ? n
    : null;
};

const trim = (text) => text.replace(/\.0+$/, "").replace(/(\.\d*?)0+$/, "$1");

export const compactPrice = (value) => {
  const n = positive(value);
  if (n == null) return null;
  if (n >= 1000000) return `$${trim((n / 1000000).toFixed(2))}M`;
  if (n >= 1000) return `$${Math.round(n / 1000)}K`;
  return `$${Math.round(n)}`;
};

const priceFact = (min, max) => {
  const top = compactPrice(max);
  const bottom = compactPrice(min);
  if (top && bottom) return `${bottom} to ${top}`;
  if (top) return `Up to ${top}`;
  return bottom ? `From ${bottom}` : null;
};

const bedsFact = (beds) => {
  const n = positive(beds);
  if (n == null) return null;
  return `${n} ${n === 1 ? "bed" : "beds"}`;
};

export const wantListingFacts = ({ budgetMin, budgetMax, bedrooms, city }) =>
  [
    priceFact(budgetMin, budgetMax),
    bedsFact(bedrooms),
    city ? String(city).trim() : null,
  ]
    .filter(Boolean)
    .join(", ");
